/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Share } from '@capacitor/share';
import {
  checkSocialSharingPluginExists,
  getURLFromPath,
} from '../../components/helpers/share-helpers';
import { callEndpoint } from '../backend';
import { captureEvent } from '../event-capture';
import { NOTIFICATIONS_PATH } from '../route/permissions';

const shareWithOptionsSuccessCallback = async (message) => {
  await captureEvent({
    type: 'share: submitted',
    payload: {
      action: 'native share',
      message: message ? 'included' : 'empty',
    },
    sendToAmplitude: true,
  });
};

export const nativeShare = async (message, url, subject = '') => {
  // If the social sharing plugin isn't available throw error
  if (!checkSocialSharingPluginExists()) {
    throw new Error('Social sharing plugin is not available');
  }

  // See possible options at: https://github.com/EddyVerbruggen/SocialSharing-PhoneGap-Plugin#4-usage-on-ios-and-android
  const options = {
    // Using shareText on layer definitions so we can customise by marker/layer type.
    text: message,
    title: subject,
    url,
    dialogTitle: 'Pick an app', // Android only, you can override the default share sheet title
  };

  await Share.share(options);

  shareWithOptionsSuccessCallback(message);
};

/**
 * Submit share information to back end.
 *
 * @param {*} required
 */
export const submitShare = async ({
  email,
  comment,
  path,
  title,
  description,
  type,
  id,
  sharedToMember,
}) => {
  const url = getURLFromPath(path);
  const notificationsRoute = getURLFromPath(NOTIFICATIONS_PATH);

  const body = {
    itemTitle: title,
    itemDescription: description,
    itemType: type,
    // we need to convert id to an int because it is stored in redux as a string.
    itemId: id ? parseInt(id, 10) : undefined,
    url,
    comment,
    sharedToEmailAddress: email,
    sharedToMember: sharedToMember ? parseInt(sharedToMember, 10) : undefined,
    notificationsRoute,
  };

  await callEndpoint(callEndpoint.endpoints.addSharingActivity, body);

  await captureEvent({
    type: 'share: submitted',
    payload: {
      action: body.sharedToMember ? 'user' : 'referral',
      message: comment ? 'included' : 'empty',
    },
    sendToAmplitude: true,
  });
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const initialize = () => {};
